import React from 'react';
import classnames from 'classnames';
import CheckBoxBar from '../CheckBoxBar';
import '@intelligence/components/GenreSelect/components/Checkboxbars/index.scss';

export interface ICheckboxbarsProps {
  className?: string;
  checkboxListClassName?: string;
  style?: any;
  search?: string;
  isNoData?: boolean;
  levelList?: any[];
  onChange?: (payload: any) => void;
  onClick?: (payload: any) => void;
}
const CheckBoxList: React.FC<ICheckboxbarsProps> = (props) => {
  const { style, className, checkboxListClassName, levelList, onChange, onClick, search, isNoData } = props;

  return (
    <>
      {isNoData ? (
        <span style={style} className={classnames('genre-no-data', className)}>
          {'No results found'}
        </span>
      ) : (
        <div style={style} className={classnames('panel-radio-bars-container', className, checkboxListClassName)}>
          <ul className="panel-radio-bars">
            {levelList?.map((levelItem: any) => {
              const levelId = levelItem?.id;
              const isActive = levelItem?.active;
              const isIndeterminate = levelItem?.state === 'partial';
              const valueCur = levelItem?.state === 'all';
              const showRightArrowCur = !levelItem?.isEndPanel;
              return (
                <li key={levelId} className="panel-radio-bar">
                  <CheckBoxBar
                    showRightArrow={showRightArrowCur}
                    active={isActive}
                    value={valueCur}
                    indeterminate={isIndeterminate}
                    search={search}
                    onChange={(payload) => {
                      onChange?.(payload);
                    }}
                    levelItem={levelItem}
                    onClick={() => {
                      onClick?.(levelItem);
                    }}
                  />
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </>
  );
};

export default CheckBoxList;
